import { useEffect, useState } from "react";
import { FaRegCircleCheck } from "react-icons/fa6";
import { MdOutlineCircle } from "react-icons/md";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { RightWrapper } from "../../../components";
import { kycSchema } from "../../../schemas";
import {
  useValidation,
  useConfirmationDialog,
  useApi,
  useFormData,
  useAlert,
} from "@/";
import { useDispatch, useSelector } from "react-redux";
import { updateKycStatus } from "../../../app/slices";
import axios from "axios";
import { z } from "zod";

const StepperContainer = () => {
  const initialState = {
    personalDetails: {
      fullName: "",
      dob: "",
      gender: "",
      phone1: "",
      phone2: "",
      email: "",
      monthlyShipments: "",
      panNumber: "",
      aadharNumber: "",
      aadhar: "", // Aadhar card photo
      pan: "", // Pan card photo
      address: {
        line1: "",
        city: "",
        state: "",
        pincode: "",
      },
    },
    businessDetails: {
      firmName: "",
      businessType: "",
      phone: "",
      gstNumber: "",
      firmPanNumber: "",
      firmPan: "", // Firm pan card photo
      firmGST: "", // Firm GST certificate photo
      firmLOGO: "", // Firm logo photo
      address: {
        line1: "",
        city: "",
        state: "",
        pincode: "",
      },
    },
    bankDetails: {
      accountHolderName: "",
      bankName: "",
      accountNumber: "",
      accountType: "",
      ifscCode: "",
      cancelledCheque: "", // Cancelled cheque photo
    },
  };
  const user = useSelector((state) => state.user?.user);
  console.log("user", user);
  const kycDetails = useSelector((state) => state.user?.user?.kycDetails);
  /* console.log("kycDetails", kycDetails); */

  const kycData = {
    personalDetails: kycDetails?.personalDetails || {},
    businessDetails: kycDetails?.businessDetails || {},
    bankDetails: kycDetails?.bankDetails || {},
  };

  const kycStatus = useSelector((state) => state.user?.user?.kycStatus);

  /*   console.log("kycStatus", kycStatus); */

  const location = useLocation();
  const { alert, AlertDialog } = useAlert();
  const navigate = useNavigate();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const { loading, error, callApi } = useApi();
  const { validate } = useValidation(kycSchema);
  const convertToFromData = useFormData();
  const dispatch = useDispatch();
  /* console.log("kycData:::", kycData); */

  /*  console.log(
    "LocalStorage>>>",
    JSON.parse(localStorage.getItem("kycFormData"))
  ); */
  /*  const [formData, setFormData] = useState(
    JSON.parse(localStorage.getItem("kycFormData")) || initialState
  ); */
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (Object.keys(kycDetails || {}).length > 0) {
      setFormData(kycData);
    }
  }, [kycDetails]);

  // Sets for tracking completed and skipped steps
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const [skippedSteps, setSkippedSteps] = useState(new Set());
  const [activeStep, setActiveStep] = useState(1);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    setIsDisabled(["approved", "pending", "rejected"].includes(kycStatus));
  }, [kycStatus]);

  const steps = [
    { name: "Personal Details", id: 1, path: "personal" },
    { name: "GST Details", id: 2, path: "gst" },
    { name: "Bank Details", id: 3, path: "bank" },
    { name: "Seller Agreement", id: 4, path: "sellerAgreement" },
  ];

  useEffect(() => {
    if (location.pathname === "/settings/kyc") {
      navigate("/settings/kyc/personal");
    }
  }, [location.pathname]);

  useEffect(() => {
    setActiveStep(
      steps.findIndex((step) => location.pathname.includes(step.path)) + 1
    );
  }, [location.pathname]);

  const handleNextStep = () => {
    if (activeStep < steps.length) {
      setCompletedSteps((prev) => new Set([...prev, activeStep]));
      // Remove the current step from skipped if it was previously skipped
      setSkippedSteps((prev) => {
        const newSet = new Set(prev);
        newSet.delete(activeStep);
        return newSet;
      });
      setActiveStep((prev) => prev + 1);
      navigate(steps[activeStep].path);
    }
  };

  const handleSkipStep = () => {
    if (activeStep < steps.length) {
      setSkippedSteps((prev) => new Set([...prev, activeStep]));
      setActiveStep((prev) => prev + 1);
      navigate(steps[activeStep].path);
    }
  };

  const handlePreviousStep = () => {
    if (activeStep > 1) {
      setCompletedSteps((prev) => {
        const newSet = new Set(prev);
        newSet.delete(activeStep - 1);
        return newSet;
      });
      setActiveStep((prev) => prev - 1);
      navigate(steps[activeStep - 2].path);
    }
  };

  const getFileExtension = (file) =>
    file instanceof File && file.name.includes(".")
      ? file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase()
      : "";

  // Encapsulated submission logic
  const submitForm = async () => {
    /* localStorage.setItem("kycFormData", JSON.stringify(formData)); */

    const submissionData = {
      personalDetails: {
        ...formData.personalDetails,
      },
      ...(skippedSteps.has(2)
        ? {}
        : {
            businessDetails: {
              ...formData.businessDetails,
            },
          }),
      bankDetails: {
        ...formData.bankDetails,
      },
    };

    console.log("Submission data:", submissionData);
    const result = validate(submissionData);
    console.log("Validation result:", result);
    if (!result.isValid) {
      const errordata = result.error.flatten().fieldErrors;
      console.log("Validation errors:", errordata);
      const errorMessages = Object.values(errordata).flat().join("\n");
      window.alert(errorMessages);
      return;
    }
    console.log("validated Data:", result.data);

    try {
      const uploadData = {
        docs: {
          aadhar: getFileExtension(result.data.personalDetails.aadhar),
          pan: getFileExtension(result.data.personalDetails.pan),
          cancelledCheque: getFileExtension(
            result.data.bankDetails.cancelledCheque
          ),
          ...(skippedSteps.has(2)
            ? {}
            : {
                firmPan: getFileExtension(result.data.businessDetails.firmPan),
                firmGST: getFileExtension(result.data.businessDetails.firmGST),
                firmLOGO: getFileExtension(
                  result.data.businessDetails.firmLOGO
                ),
              }),
        },
        clientId: user?.clientId || "",
      };
      console.log("uploadData", uploadData);

      const uploadDataResponse = await callApi(
        "/user/upload/kyc",
        "POST",
        uploadData
      );

      if (!uploadDataResponse.success) {
        alert(uploadDataResponse.error.message || uploadDataResponse.error);
        return;
      }

      const files = {
        aadhar: result.data.personalDetails.aadhar,
        pan: result.data.personalDetails.pan,
        cancelledCheque: result.data.bankDetails.cancelledCheque,
        ...(skippedSteps.has(2)
          ? {}
          : {
              firmPan: result.data.businessDetails.firmPan,
              firmGST: result.data.businessDetails.firmGST,
              firmLOGO: result.data.businessDetails.firmLOGO,
            }),
      };
      const responses = await Promise.all(
        uploadDataResponse?.data?.presignedUrls.map(async (object) => {
          const response = await axios.put(object.url, files[object.doc], {
            headers: {
              "Content-Type": files[object.doc].type,
            },
          });
          return response;
        })
      );

      if (responses.length > 0) {
        result.data.personalDetails.aadhar =
          responses[0]?.status === 200 ? true : false;
        result.data.personalDetails.pan =
          responses[1]?.status === 200 ? true : false;
        result.data.bankDetails.cancelledCheque =
          responses[2]?.status === 200 ? true : false;
        if (!skippedSteps.has(2)) {
          result.data.businessDetails.firmPan =
            responses[3]?.status === 200 ? true : false;
          result.data.businessDetails.firmGST =
            responses[4]?.status === 200 ? true : false;
          result.data.businessDetails.firmLOGO =
            responses[5]?.status === 200 ? true : false;
        }
      }

      console.log("uploadDataResponse>>>", uploadDataResponse);
      console.log("responses>>>", responses);

      console.log("formData:::>>>>:", result.data);
      const finalData = {
        ...result.data,
        kycDocuments: { ...uploadData.docs },
        clientId: user?.clientId,
      };

      console.log("Submitting formData:", finalData);

      const response = await callApi("user/kyc", "POST", finalData);

      // Check if the registration was successful
      if (response.success) {
        await alert("KYC submitted successfully");
        dispatch(updateKycStatus(response.data.status));
        navigate("/settings"); // Redirect to login page on success
      } else {
        // Display API-specific error message
        console.log("Kyc submission failed:", response);
        alert(response.error.message || response.error);
        //setFormError([]);
        //setGeneralError(response.error || "Login failed. Please try again.");
      }
    } catch (error) {
      // Handle unexpected errors (e.g., network issues)
      console.error("Unexpected error during submitting kyc:", error);
      // setGeneralError(
      //   error.message || "Something went wrong. Please try again."
      // );
    }
  };

  // Use the custom confirm function to open the modal and wait for user action
  const handleSubmit = async () => {
    try {
      await confirm("Are you sure you have filled all the details correctly?");
      submitForm();
    } catch (e) {
      console.log("Submission cancelled");
    }
  };

  return (
    <RightWrapper>
      <div className="flex gap-4 h-[calc(100%-4px)] md:pb-0">
        {/* Sidebar */}
        <div className="hidden md:flex h-full md:w-56 bg-secondary/5 flex-col gap-6 p-6 rounded-xl">
          <h2 className="text-subtitle1 font-ptsans text-secondary/60">{`Step ${activeStep}/4`}</h2>
          <ul className="flex flex-col gap-4 mt-8">
            {steps.map((step) => {
              const isActive = activeStep === step.id;
              const isCompleted = completedSteps.has(step.id);
              const isSkipped = skippedSteps.has(step.id);
              return (
                <li
                  key={step.id}
                  onClick={() => {
                    if (isCompleted) navigate(step.path);
                  }}
                  className={`flex items-center space-x-2 ${
                    isActive
                      ? "text-secondary/75"
                      : isCompleted
                      ? "text-secondary/50"
                      : "text-secondary/30"
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    {isCompleted ? (
                      <FaRegCircleCheck size={24} className="text-ternary" />
                    ) : (
                      <MdOutlineCircle
                        size={24}
                        className={
                          isActive ? "text-secondary/75" : "text-secondary/30"
                        }
                      />
                    )}
                  </div>
                  <span>{step.name}</span>
                  {isSkipped ||
                    (step.id == 2 &&
                      kycData?.businessDetails?.address?.line1 === null && (
                        <span className="ml-2 text-xs text-red-600 bg-red-200/60 px-1.5 py-[1.8px] border font-nunito border-red-600/20 rounded-[8px] leading-4">
                          Skipped
                        </span>
                      ))}
                </li>
              );
            })}
          </ul>

          {kycStatus && (
            <div className="mt-8">
              <div
                className={`px-3 py-2 rounded-lg border border-dashed ${
                  kycStatus === "approved"
                    ? "bg-green-100/40 text-green-800/90 border-green-800/20"
                    : kycStatus === "pending"
                    ? "bg-yellow-100/40 text-yellow-800/90 border-yellow-800/20"
                    : "bg-red-100/40 text-red-800/90 border-red-800/20"
                }`}
              >
                {kycStatus === "approved" && (
                  <span className="text-xs font-nunito">
                    Your KYC is Approved
                  </span>
                )}
                {kycStatus === "pending" && (
                  <span className="text-xs font-nunito">
                    Your KYC is Pending
                  </span>
                )}
                {kycStatus === "rejected" && (
                  <span className="text-xs font-nunito">
                    Your KYC is Rejected
                  </span>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Main Content */}
        <div className="w-full h-full flex-1 overflow-y-auto ">
          <Outlet
            context={{
              formData,
              setFormData,
              handleNextStep,
              handlePreviousStep,
              handleSkipStep,
              handleSubmit,
              isDisabled,
            }}
          />
        </div>
      </div>

      {/* Render the modal once at the root of this component */}
      <ConfirmationModal />
      <AlertDialog />
    </RightWrapper>
  );
};

export default StepperContainer;
